import utils from 'utils';
import config from 'config';
import auth from 'API/handlers/auth';
import track from 'utils/dio/zendesk';
import gfhTheme from '@guestyci/foundation/theme/gfhTheme';

declare global {
  interface Window {
    zE: any;
    zESettings: any;
  }
}

const injectScript = async (key: string) => {
  const scriptTag = document.createElement('script');
  scriptTag.id = 'ze-snippet';
  scriptTag.type = 'text/javascript';
  scriptTag.async = true;
  scriptTag.src = `https://static.zdassets.com/ekr/snippet.js?key=${key}`;

  return new Promise((resolve) => {
    scriptTag.onload = resolve;
    document.body.appendChild(scriptTag);
  });
};

const initZendeskWidget = async () => {
  if (window.zE) return window.zE('webWidget', 'show');
  const { authenticatedData, emailAddress } = utils.getLocalStorageByKey(
    'authenticatedData',
    'emailAddress'
  );

  window.zESettings = {
    webWidget: {
      helpCenter: {
        messageButton: {
          '*': 'Contact us',
        },
      },
      color: {
        theme: gfhTheme.palette.primary.default,
      },
      launcher: {
        label: {
          '*': '\u22EE',
        },
      },
      authenticate: {
        jwtFn: (callback: () => void) => {
          auth.zendeskWidgetToken().then(callback);
        },
      },
    },
  };

  await injectScript(config.zendeskWidgetKey);
  const fullName = `${authenticatedData.baseUserInfo.firstName} ${authenticatedData.baseUserInfo.lastName}`;

  window.zE('webWidget', 'prefill', {
    name: {
      value: fullName,
      readOnly: true, // optional
    },
    email: {
      value: emailAddress,
      readOnly: true, // optional
    },
  });

  window.zE('webWidget', 'helpCenter:setSuggestions', { labels: ['Top'] });
  window.zE('webWidget:on', 'userEvent', (e: any) => {
    switch (e.action) {
      case 'Web Widget Opened':
        track.webWidgetOpened();
        break;
      case 'Help Center Search':
        track.helpCenterSearch(e.properties);
        break;
      case 'Help Center Article Viewed':
        track.helpCenterArticleViewed(e.properties);
        break;
      case 'Help Center View Original Article Clicked':
        track.helpCenterViewOriginalArticleClicked(e.properties);
        break;
      case 'Help Center Shown':
        track.helpCenterShown();
        break;
      case 'Contact Form Shown':
        track.contactFormShown();
        break;
      case 'Contact Form Submitted':
        track.contactFormSubmitted();
        break;
      case 'Web Widget Minimised':
        track.webWidgetMinimised();
        break;
      default:
        break;
    }
  });
};

export default initZendeskWidget;
